// components/chat/CallThreadEntry.jsx
// A missed/declined call rendered INTO the DM thread (spec 04), so it's findable
// later — not a vanishing toast. Built from a CallLog row.
//   entry = { status: 'missed'|'declined', call_type, direction, other_name, ts }
import React from "react";
import { PhoneMissed, PhoneOff, MessageCircle, Phone, Video } from "lucide-react";

const GREEN = "#00FF99";
const RED   = "#ff5f56";

const niceAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso), diff = Math.floor((Date.now() - d.getTime()) / 60000);
  if (diff < 1) return "just now";
  if (diff < 60) return `${diff} min ago`;
  if (diff < 1440) return `${Math.floor(diff / 60)}h ago`;
  return d.toLocaleDateString([], { day: "2-digit", month: "short" });
};

export default function CallThreadEntry({ entry, onMessage, onCallBack }) {
  const isAudio  = entry.call_type === "audio";
  const declined = entry.status === "declined";
  const StatusIcon = declined ? PhoneOff : PhoneMissed;
  const label = declined
    ? (entry.direction === "outgoing" ? "Call declined" : "You declined")
    : `Missed ${isAudio ? "audio" : "video"} call`;

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%", margin: "4px 0" }}>
      <div style={{
        width: 300, maxWidth: "85%", background: "rgba(13,13,13,0.97)",
        border: "1px solid rgba(255,95,86,0.35)", borderRadius: 16, padding: 12,
        boxShadow: "0 8px 28px rgba(0,0,0,0.5)",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{
            width: 34, height: 34, borderRadius: 999, flex: "none", display: "grid", placeItems: "center",
            background: "rgba(255,95,86,0.10)", border: `1px solid ${RED}66`, color: RED,
          }}>
            <StatusIcon size={16} strokeWidth={1.9} />
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#fff" }}>{entry.other_name || "Call"}</div>
            <div style={{ fontSize: 10, color: RED, marginTop: 1 }}>{label} · {niceAgo(entry.ts)}</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 11 }}>
          <button onClick={onMessage}
            style={{ flex: 1, display: "flex", gap: 6, alignItems: "center", justifyContent: "center", borderRadius: 999, padding: "8px 0", fontSize: 11.5, fontWeight: 600, cursor: "pointer", background: "transparent", border: "1px solid rgba(255,255,255,0.10)", color: "rgba(255,255,255,0.55)" }}>
            <MessageCircle size={14} strokeWidth={1.9} /> Message
          </button>
          <button onClick={() => onCallBack?.(isAudio)}
            style={{ flex: 1, display: "flex", gap: 6, alignItems: "center", justifyContent: "center", borderRadius: 999, padding: "8px 0", fontSize: 11.5, fontWeight: 600, cursor: "pointer", background: "transparent", border: `1px solid ${GREEN}4d`, color: GREEN }}>
            {isAudio ? <Phone size={14} strokeWidth={1.9} /> : <Video size={14} strokeWidth={1.9} />} Call back
          </button>
        </div>
      </div>
    </div>
  );
}
